<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
          <h5 class="font-black">{{tituloDeBusqueda}}</h5>
      </div>
      <hr class="mt-1" />    
      <div class="row">
      <div v-if="descripcionDeBusqueda!=null" class="col-12 form-group" id="seleccione_div">     
          <h6 class="font-black">{{descripcionDeBusqueda}}</h6>
     </div>

        <div v-for="catalogo in catalogos" :key="'KeyIdentificador_' + catalogo.catalogoId" class="col-12">     
            <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">  
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales  && !esJuzgadoExterno && !esOrdenDeProteccion" id="PartidosJudiciales_div">
                  <h6 class="font-black">Partido Judicial</h6>
                  <C009PartidosJudiciales 
                      :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" 
                      v-on:valorParaElPadre="cambioDePartidoJudicialEvento" 
                      v-on:valorParaElPadrePrimerElemento="cambioDePartidoJudicial"
                      :prefijo="catalogo.etiquetaDeHtml" 
                      :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect"
                      :idDelInput="catalogo.idDelInput" 
                      :parametros="parametros_PartidoJudicial.parametros"
                      :valorDefinido="parametros_PartidoJudicial.partidoJudicialId"
                      :key="parametros_PartidoJudicial.key">
                  </C009PartidosJudiciales>
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados  && !esJuzgadoExterno && !esOrdenDeProteccion" id="Juzgados_div">
                  <h6 class="font-black">Juzgado</h6>
                  <C001Area
                    :class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" 
                    v-on:valorParaElPadre="cambioDeAreaEvento" 
                    v-on:valorParaElPadrePrimerElemento="cambioDeArea"
                    :prefijo="catalogo.etiquetaDeHtml" 
                    :tipo="catalogo.tipoDeSelect"  
                    :idDelInput="catalogo.idDelInput" 
                    :parametros="parametros_Area.parametros" 
                    :valorDefinido="parametros_Area.areaId" 
                    :key="parametros_Area.key">
                  </C001Area>
              </div>
              <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados && esJuzgadoExterno" id="JuzgadoExterno_div">
                  <h6>Ingrese Juzgado Externo</h6>
                  <input class="form-control" type="text" placeholder="Nombre del Juzgado" id="juzgadoExternoNombre" v-model="juzgadoExternoNombre" @input="(val) => (juzgadoExternoNombre = juzgadoExternoNombre.toUpperCase())"/>
              </div> 
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Materias && !esOrdenDeProteccion" id="Materias_div">
                  <h6 class="font-black">Materia</h6>
                  <C002Materias 
                    :class="[parametros_Materia.esInformativo ? 'catalogoInformativo' : '']" 
                    v-on:valorParaElPadre="cambioDeMateriaEvento" 
                    v-on:valorParaElPadrePrimerElemento="cambioDeMateria" 
                    :prefijo="catalogo.etiquetaDeHtml" 
                    :tipo="area!= undefined && area!= null? enumeraciones.tiposDeSelect.Ninguno : catalogo.tipoDeSelect" 
                    :idDelInput="catalogo.idDelInput" 
                    :parametros="parametros_Materia.parametros" 
                    :valorDefinido="parametros_Materia.materiaId" 
                    :key="parametros_Materia.key">
                  </C002Materias>
              </div>   
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos /*&& condinciones*/&& !esOrdenDeProteccion" id="TiposDeDocumentos_div">
                  <h6 class="font-black">Tipo de documento</h6>
                  <C004TiposDocumento 
                    :class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" 
                    v-on:valorParaElPadre="cambioDeTipoDeDocumento" 
                    :prefijo="catalogo.etiquetaDeHtml" 
                    :tipo="catalogo.tipoDeSelect" 
                    :idDelInput="catalogo.idDelInput" 
                    :parametros="parametros_TipoDocumento.parametros" 
                    :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" 
                    :key="parametros_TipoDocumento.key">
                  </C004TiposDocumento>
              </div>
              <div class="form-group" v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (parametros_TipoDocumento.tipoDocumentoId > 0) && !esOrdenDeProteccion" id="Consecutivo_div">
                  <h6 class="font-black">Consecutivo</h6>
                  <input class="form-control campos" type="text" placeholder="####/####" v-model="consecutivo" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros"  @keyup.enter='ejecutaLaFuncion()' v-mask="'####/####'" />
              </div>  
              <div v-if="esAreaDeEjecucion && catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && (consecutivo && consecutivo.length == 9)">
                  <h6>Número romano</h6>
                  <input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="Numero Romano" @input="(val) => (numeroRomano = numeroRomano.toUpperCase())" @keypress="esRomano($event)"/>
              </div>
              <div v-if="mostrarNumeroExtra && catalogo.catalogoId == enumeraciones.catalogos.NumeroExtra && !esOrdenDeProteccion" >
                <h6 class="font-black">Número</h6>
                <input class="form-control" type="text" placeholder="##" v-model="numeroExtra" id="NumeroExtra_div" @change="cambioDeNumeroExtra($event)" v-mask="'##'" @keyup.enter='ejecutaLaFuncion()' />
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && esOrdenDeProteccion" class="col-12 form-group" id="fecha_inicio_div">
                  <h6 class="font-black">Fecha Inicio</h6><input class="form-control" type="date"  v-model="fechaInicio" id="fechaInicio"  
                     autocomplete="off" @paste.prevent/>

              </div>   
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && esOrdenDeProteccion"  class="col-12 form-group" id="fecha_fin_div">
                  <h6 class="font-black">Fecha Fin</h6><input class="form-control campos" type="date"  v-model="fechaFin" id="fechaFin" :min="fechaMaxima" 
                     autocomplete="off" @paste.prevent/>
                  
              </div>  
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && esOrdenDeProteccion" class="col-12 form-group" id="motivo_div" >
                <h6 class="font-black">Motivo</h6>
                  <input class="form-control campos" type="text" v-model="motivo" id="motivo"  autocomplete="off" @input="(val) => (motivo = motivo.toUpperCase())"/>
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales && esOrdenDeProteccion" class="col-12 form-group" id="Dependencia_div">
                  <h6 class="font-black">Dependencia</h6>
                  <C002TiposDependencias 
                    :class="[parametros_Dependencia.esInformativo ? 'catalogoInformativo' : '']" 
                    v-on:valorParaElPadre="cambioDeDependenciaEvento" 
                    v-on:valorParaElPadrePrimerElemento="cambioDeDependencia" 
                    :prefijo="catalogo.etiquetaDeHtml" 
                    :tipo="catalogo.tipoDeSelect" 
                    :idDelInput="catalogo.idDelInput" 
                    :parametros="parametros_Dependencia.parametros" 
                    :valorDefinido="parametros_Dependencia.dependenciaId" 
                    :key="parametros_Dependencia.key">
                  </C002TiposDependencias>
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales && esOrdenDeProteccion" class="col-12 form-group" id="Envio_div">
                  <h6 class="font-black">Tipo de Envio</h6>
                  <C003TiposEnvio 
                    :class="[parametros_TipoEnvio.esInformativo ? 'catalogoInformativo' : '']" 
                    v-on:valorParaElPadre="cambioDeTipoEnvioEvento" 
                    v-on:valorParaElPadrePrimerElemento="cambioDeTipoEnvio" 
                    :prefijo="catalogo.etiquetaDeHtml" 
                    :tipo="catalogo.tipoDeSelect" 
                    :idDelInput="catalogo.idDelInput" 
                    :parametros="parametros_TipoEnvio.parametros" 
                    :valorDefinido="parametros_TipoEnvio.tipoEnvioId" 
                    :key="parametros_TipoEnvio.key">
                  </C003TiposEnvio>
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && esOrdenDeProteccion"  class="col-12 form-group" id="correoEnvia_div" >
                <h6 class="font-black">Correo Envia</h6>
                <input class="form-control" type="text" v-model="correoEnvia" id="correoEnvia"  autocomplete="off">
              </div>
              <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Consecutivo && esOrdenDeProteccion"  class="col-12 form-group" id="correoRecibe_div" >
                <h6 class="font-black">Correo Recibe</h6>
                <input class="form-control" type="text" v-model="correoRecibe" id="correoRecibe"  autocomplete="off">
              </div>
            </div>
          </div>
       </div>
       <div id="RealizarFiltrosBusqueda_div" class="row justify-content-between mx-1" >
          <button class=" btn btn-ligth overwrapDeBotones p-2 text-white" style="background-color:#004746" @click="limpiarFiltros(); " id="limpiar"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>
            <button v-if="!esOrdenDeProteccion" class="btn btn-ligth overwrapDeBotones p-2 text-white" style="background-color:#004746" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search fa-lg" ></i>&nbsp;&nbsp;Buscar</button>          
            <button v-if="esOrdenDeProteccion" class="btn btn-ligth overwrapDeBotones p-2 text-white" style="background-color:#004746" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>          
          
        </div>
    </div>
</div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import JQuery from 'jquery'
  import { servicioRestPost } from '../../Audiencias/Programacion/servicios/ServiciosHttp.js'
  import Multiselect from 'vue-multiselect'
  import func from './Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    directives: {
        tooltipF
    },
    data() {
      return {
        enumeraciones,
        consecutivo: "",
        numeroRomano: null,
        numeroExtra: '',
        juzgadoExternoNombre: null,
        juzgadoSeleccionado: null,
        mostrarNumeroExtra: false,  
        esAreaDeEjecucion: false,  
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: -1,
          parametros: {},
          esInformativo: true
        },
        parametros_Materia: {
          key: "",
          materiaId: -1,
          parametros: {},
          esInformativo: true
        },
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {},
          esInformativo: false
        },   
        parametros_Dependencia: {
          key: "",
          dependenciaId: -1,
          parametros: {
            ConOrdenPorNombre: true
          },
          esInformativo: false
        }, 
        parametros_TipoEnvio:{
          key: "",
          tipoEnvioId: -1,
          parametros:{},
          esInformativo: false,
        },
        fechaInicio: null,
        fechaFin: null,
        fechaMaxima: new Date().toISOString().slice(0,10),
        motivo: null,      
        correoEnvia: null,
        correoRecibe: null,  
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C002TiposDependencias: catalogos.REGOP.C002TiposDependencias,
      C003TiposEnvio: catalogos.REGOP.C003TiposEnvio,
    },
    props: {
      tituloDeBusqueda: String,
      descripcionDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      elementosAConservar2: Object,
      elementosAConservarTocaCF: Object,
      elementosAConservarTocaSAE: Object,
      ejecutaLaFuncion: Function,
      area: null,
      datosToca: false,
      esJuzgadoExterno: false,
      esOrdenDeProteccion: false,
      dependencia: null,
      tipoEnvio: null,
    },
    mounted(){            
      if(this.elementosAOmitir){ //
        if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
          this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
          this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
        }
        if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
          this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
          this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
        }
        if(this.elementosAOmitir.tiposDocumento && this.elementosAOmitir.tiposDocumento.length > 0){
          this.parametros_TipoDocumento.parametros.elementosAOmitir = this.elementosAOmitir.tiposDocumento;
          this.parametros_TipoDocumento.key = "elementosOmitir_" + this.elementosAOmitir.tiposDocumento.length;
        }


      }
      // if(this.datosToca == true){
      //     this.parametros_PartidoJudicial.esInformativo = false;   
      //   }    
            // //this.parametros_PartidoJudicial.partidoJudicialId= 1;
     if(!this.area)
        this.cambioDePartidoJudicial(parseInt(this.parametros_PartidoJudicial.partidoJudicialId));


      
      //this.parametros_Area.parametros.SistemaId = 42;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true;
    },
    beforeMount(){
      if(this.dependencia != undefined && this.dependencia != null){
        this.parametros_Dependencia.dependenciaId = this.dependencia;
      }
      if(this.tipoEnvio != undefined && this.tipoEnvio != null){
        this.parametros_TipoEnvio.tipoEnvioId = this.tipoEnvio;
      }
      if((this.area != undefined && this.area != null) &&  this.area.AreaId!=27 && this.area.AreaId!=114 && this.area.AreaId!=1 ){
        this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.AreaId = this.area.AreaId;
        this.parametros_Materia.parametros.AreaId = this.area.AreaId;
        this.parametros_Area.parametros.conInactivos = true;

        if(this.elementosAConservar){ 
         if(this.elementosAConservar.materias && this.elementosAConservar.materias.length > 0){
             this.parametros_Materia.parametros.elementosAConservar = this.elementosAConservar.materias;
             this.parametros_Materia.key = "elementosAConservar_" + this.elementosAConservar.materias.length;     
         }

         if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
         }
         if(this.elementosAConservar.tiposDocumento && this.elementosAConservar.tiposDocumento.length > 0){
          this.parametros_TipoDocumento.parametros.elementosAConservar = this.elementosAConservar.tiposDocumento;
          this.parametros_TipoDocumento.key = "elementosAConservar_" + this.elementosAConservar.tiposDocumento.length;     
         }
        }
       }   

       else{


        // if(this.elementosAConservar.partidosJudiciales && this.elementosAConservar.partidosJudiciales.length > 0){
        //   this.parametros_PartidoJudicial.parametros.elementosAConservar = this.elementosAConservar.partidosJudiciales;
        //   this.parametros_PartidoJudicial.key = "elementosAConservar_" + this.elementosAConservar.partidosJudiciales.length;
        // }               
        if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
        }
        if(this.elementosAConservar.tiposDocumento && this.elementosAConservar.tiposDocumento.length > 0){
          this.parametros_TipoDocumento.parametros.elementosAConservar = this.elementosAConservar.tiposDocumento;
          this.parametros_TipoDocumento.key = "elementosAConservar_" + this.elementosAConservar.tiposDocumento.length;     
        }
        // if(this.elementosAConservar.materias && this.elementosAConservar.materias.length > 0){
        //   this.parametros_Materia.parametros.elementosAConservar = this.elementosAConservar.materias;
        //   this.parametros_Materia.key = "elementosAConservar_" + this.elementosAConservar.materias.length;     
        // }
        // if(this.elementosAConservar.entidades && this.elementosAConservar.entidades.length > 0){
        //   this.parametros_Entidades.parametros.elementosAConservar = this.elementosAConservar.entidades;
        //   this.parametros_Entidades.key = "elementosAConservar_" + this.elementosAConservar.entidades.length;     
        // }




      }

      //this.cambioDeTipoDeDocumento(parseInt(this.parametros_TipoDocumento.tipoDocumentoId));
    },
    created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);  

    },

    methods: {      
      /**
       * Método encargado de actualizar/cambiar el campo del Consecutivo.
       * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       */
      cambioDeConsecutivo(datos) { 
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      /**
       * Método encargado de actualizar/cambiar el campo Partido Judicial
       * @param {event.target} datos [datos: nuevo valor del Partido Judicial]
       */
      cambioDePartidoJudicialEvento(datos) {
        this.cambioDePartidoJudicial(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id Partido Judicial
       * @param {int} id [id: identificador del Partido Judicial]
       */
      cambioDePartidoJudicial(id) {
        this.parametros_PartidoJudicial.partidoJudicialId = id;

        //Actualizo area
        /**/
        this.parametros_Area.areaId = -1; 
        this.parametros_Area.parametros.AreaId = -1;   
        this.parametros_Area.key += 1;
        /**/
        this.parametros_Area.parametros.PartidoJudicialId = id;
        this.parametros_Area.key = "PartidoJudicial_" + id;        

        /**/
        this.parametros_Materia.materiaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;    
        this.parametros_Materia.key += 1; 
        
        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;
        /**/
      },            
      /**
       * Método encargado de actualizar/cambiar el campo Materia
       * @param {event.target} datos [datos: nuevo valor del Materia]
       */
      cambioDeMateriaEvento(datos) {
        this.cambioDeMateria(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Materia
       * @param {int} id [id: identificador del Materia]
       */
      cambioDeMateria(id) {
        this.parametros_Materia.materiaId = id;
        
        //Actualizo area
        this.parametros_Area.parametros.MateriaId = id;
        if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_Area.key = "Materia_" + id;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = id;
        if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0)
          this.parametros_TipoDocumento.key = "Materia_" + id;
        

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0){}
            //this.obtenerFiltradoTipoDeDocumentosAPI();
      },
      /**
       * Método encargado de actualizar/cambiar el campo Area
       * @param {event.target} datos [datos: nuevo valor del Area]
       */
      cambioDeAreaEvento: function(datos) {
        this.cambioDeArea(parseInt(datos.target.value));

        if(this.parametros_Area.areaId==12){
         this.numeroRomano = null;
         }
         this.juzgadoSeleccionado = datos.target.options[datos.target.options.selectedIndex].text;
      },
      /**
       * Método encargado de actualizar/cambiar el id de Area
       * @param {int} id [id: identificador del Area]
       */
      cambioDeArea: function(id) {
        this.parametros_Area.areaId = id;

        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = id;
        if (this.parametros_PartidoJudicial.partidoJudicialId <= 0 || this.parametros_Area.areaId <= 0)
          this.parametros_PartidoJudicial.key = "Area_" + id;

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = id;
        /**/
        this.parametros_Materia.materiaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;    
        this.parametros_Materia.key += 1; 
        /**/        
        this.parametros_Materia.key = "Area_" + id;          

        if(this.parametros_Area.areaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
          this.esAreaDeEjecucion = true;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.AreaId = id;
        /**/
        this.parametros_TipoDocumento.tipoDocumentoId = -1;             
        this.parametros_TipoDocumento.key += 1;
        /**/
        this.parametros_TipoDocumento.key = "Area_" + id;

        //Filtrar tipos de documentos según a DB a consultar
        if(this.parametros_Materia.materiaId != undefined && this.parametros_Materia.materiaId !=null && this.parametros_Materia.materiaId > 0 &&
           this.parametros_Area.areaId != undefined && this.parametros_Area.areaId !=null && this.parametros_Area.areaId > 0){}     
              //this.obtenerFiltradoTipoDeDocumentosAPI()
      },      
      /**
       * Método encargado de actualizar/cambiar el campo Tipo de Documento
       * @param {event.target} datos [datos: nuevo valor del Tipo de Documento]
       */
      cambioDeTipoDeDocumento(datos) {
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0)
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;
        //Mostramos número extra de consecutivo si es Tercería o Incidente.

        if(this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente)
          this.mostrarNumeroExtra = true;
        else
          this.mostrarNumeroExtra = false;  
        if(this.parametros_TipoDocumento.tipoDocumentoId==-1){
          this.consecutivo = null;
        }        
      }, 
      cambioDeNumeroExtra(datos) {
        this.$store.dispatch("A_Comun_NumeroExtra", datos.target.value);
      },
      cambioDeDependenciaEvento(datos){
        this.cambioDeDependencia(parseInt(datos.target.value));
      },

      cambioDeDependencia(id){
        this.parametros_Dependencia.dependenciaId = id;
      }, 
      
      cambioDeTipoEnvio(id){
        this.parametros_TipoEnvio.tipoEnvioId = id;
      },

      cambioDeTipoEnvioEvento(datos){
        this.cambioDeTipoEnvio(parseInt(datos.target.value));
      },


      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI(){
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          //MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            (this.area != null) ? api.conexion + api.SITA.sistema.administracion.tocas.ObtenerTiposDeDocumentosIdYDBId :
                             api.conexion + api.SITA.sistema.administracion.tocas.ObtenerTiposDeDocumentosIdYDBIdExpedienteAntecedente , 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError){
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } 
            else{
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      limpiarFiltros: function(){
        this.parametros_PartidoJudicial.partidoJudicialId = 1;
        this.parametros_PartidoJudicial.parametros.PartidoJudicialId = this.area != null ? 1 : -1;;
        this.parametros_PartidoJudicial.parametros.AreaId = -1;
        this.parametros_PartidoJudicial.parametros.MateriaId = -1; 
        this.parametros_PartidoJudicial.key += 1;  

        this.parametros_Materia.materiaId = -1;
        this.parametros_Materia.parametros.PartidoJudicialId = 1;
        //this.parametsros_Materia.parametros.AreaId = -1;
        this.parametros_Materia.parametros.MateriaId = -1;
        this.parametros_Materia.parametros.TipoDocumentoId = -1;      
        this.parametros_Materia.key += 1;

        this.parametros_Area.areaId = this.area != null ? this.area.AreaId : -1;
        this.parametros_Area.parametros.PartidoJudicialId = 1;
        //this.parametros_Area.parametros.AreaId = -1;
        this.parametros_Area.parametros.MateriaId = -1;
        this.parametros_Area.key += 1;

        this.parametros_TipoDocumento.parametros.PartidoJudicialId = 1;
        this.parametros_TipoDocumento.parametros.AreaId = -1;
        this.parametros_TipoDocumento.parametros.MateriaId = -1;  

        this.parametros_TipoDocumento.tipoDocumentoId = -1;     
        this.parametros_TipoDocumento.key += 1;   

        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null; 
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null;             
        this.esAreaDeEjecucion = false;

        this.juzgadoExternoNombre = null;

        this.materia = null;
        this.persona = false;
        this.numeroRomano = null;
        
        this.fechaInicio = null;
        this.fechaFin = null;
        this.motivo = null;

        this.parametros_Dependencia.dependenciaId = -1;
        this.parametros_Dependencia.key += 1;

        this.parametros_TipoEnvio.tipoEnvioId = -1;
        this.parametros_TipoEnvio.key += 1;
      },

      esLetra(datos){
        return func.esLetra(datos)
      },


      esDireccion(datos){
        return func.esDireccion(datos)
      },

      esRomano(datos){
        return func.esRomano(datos)
      },

    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"> </style>

<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
  </style>


<style >
  
  .multiselect__tags {
      background:#504f54 !important;
      border: none !important ;
      font-size: 0.9rem !important;
      padding: 0 0.75rem;
      min-height: calc(2rem);

     
  }


  .multiselect__option {
   
    font-size: 0.9rem !important;
    min-height: calc(2rem) !important;
    line-height: 0.9rem !important;

 
 }




  /*.multiselect__select {

    color:aqua !important;


  }*/

  .multiselect__placeholder{
    color:  #FFF !important;
  }


  .multiselect__option--selected {
    background: #817f8b !important;
    color: #35495e;
   /* font-weight: 700;*/
}


.multiselect__select:before {
    border-color: #FFF transparent transparent;
    
}


.multiselect__content-wrapper {
   
    background: #FFF !important;
   
}


.multiselect__option--highlight {
    background: #007bff !important;
}
  .campos{
    background-color: var(--blanco-pj);
    color: black;
  }
  .font-black{
    color: black;
  } 


  

  </style>




  







// WEBPACK FOOTER //
// src/components/REGOP/Comun/FiltrosDeBusqueda.vue